var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Preact from 'preact';
import * as IconButton from '../A_IconButton';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
export var Component = function (props) {
    return (Preact.h(Box, { sx: __assign({ height: '64px', width: '100%', padding: '16px', boxSizing: 'border-box', display: 'grid', gridTemplateAreas: "'back title close'", gridTemplateColumns: '32px auto 32px', alignItems: 'center', background: 'white', borderBottom: '1px solid rgba(0, 0, 0, .15)' }, props.sx) },
        props.onBackClick && (Preact.h(IconButton.Component, { color: "secondary", size: "small", onClick: props.onBackClick, sx: { gridArea: 'back' } },
            Preact.h(ArrowBackIcon, null))),
        props.title && (Preact.h(Typography, { textAlign: "center", variant: "h6", sx: { gridArea: 'title' } }, props.title)),
        Preact.h(IconButton.Component, { color: "secondary", size: "small", onClick: props.onCloseClick, sx: { gridArea: 'close' } },
            Preact.h(CloseIcon, null))));
};
Component.displayName = 'ModalTitle';
